import styled from "styled-components";
import { COLORS, HELPERS } from "../../shared";
import { MEDIA_QUERY } from "../../entities/Common";

export const AsideStyled = styled.aside`
  width: 100px;
  .aside {
    &-item {
      width: 100px;
      min-height: 100px;
      padding-top: 15px;
      padding-bottom: 15px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: ${COLORS.GRAY};
      transition: ${HELPERS.TRANSITION};
      text-decoration: none;
      text-align: center;
      padding-left: 5px;
      padding-right: 5px;
      outline: none;
      box-sizing: border-box;
      &.active {
        background: ${COLORS.WHITE};
        box-shadow: 0 3px 20px #00000029;
      }
      &__name {
        font-size: 14px;
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_VERTICAL}) {
    width: auto;
    .aside {
      &-items {
        display: flex;
      }
      &-item {
        width: 20%;
      }
    }
  }
  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    position: relative;
    left: -20px;
    width: calc(100% + 40px);
    overflow-y: scroll;
    .aside {
      position: relative;

      &-item {
        width: 100px;
      }
      &-items {
        width: 500px;
      }
      &-item {
        &__name {
          font-size: 12px;
          line-height: 1.3;
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &.active {
          box-shadow: none;
        }
      }
    }
  }
`;
